import React, { useState, useEffect } from 'react'
// import Filter from './filter'
import Search from './Search'
import Card from './hospital-card'
import { srGetHospitalList } from '../../sources/book-appointments';
import lodash from 'lodash'
import { parseQueryString } from '../../utils/utils'
import { useAppState } from '../../contexts/appState'
import { useIsMobile } from '../../hooks/breakpoints'
import useTranslation from '../../hooks/use-translation';
import ErrorComponent from '../Error-Component'
import BookErrorIcon from '../../images/Error_IMG.svg'
import { raiseGAEventForVaccination, sendPageViewEvent } from '../../utils/network'
import config from '../../config.json'
let userLocationFromPincode = {
  latitude: '',
  longitude: '',
  city: ''
}
let searchKeyword = {
  value: ''
}
export default (props) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const [searchKey, setSearchKey] = useState('')
  const [loading, setLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [pageCount, setPageCount] = useState(1)
  const [userLocationFromDetect, setUserLocationFromDetect] = useState({
    latitude: '',
    longitude: '',
    city: '',
    usePincode: true,
    pincode: '400701'
  })
  const params = parseQueryString()
  const [{ location }] = useAppState()
  const [completeCenterList, setCompleteCenterList] = useState([])
  const [centerListResponse, setCenterListResponse] = useState({})
  const [pageLength, setPageLength] = useState('')
  const vaccine_options = [
    {
      value: '1',
      label: 'Select Name'
    },
    {
      value: '2',
      label: 'Covaxin'
    },
    {
      value: '3',
      label: 'Pfizer'
    },
    {
      value: '4',
      label: 'Covishield'
    }
  ]
  let reqDataCenters = {
    'per_page': '20',
    'page': pageCount.toString(),
    'tags_filter': props.flow === 'corporate' ? 'corporate' : 'public',
    'lng': userLocationFromDetect.usePincode ? userLocationFromPincode?.longitude : userLocationFromDetect.longitude,
    'lat': userLocationFromDetect.usePincode ? userLocationFromPincode?.latitude : userLocationFromDetect.latitude,
    'city_name': userLocationFromDetect.usePincode ? userLocationFromPincode?.city : userLocationFromDetect.city,
    'keyword': searchKeyword.value
  }
  const getCentersList = async (isKeyWordLengthIsZero = false) => {
    if (isKeyWordLengthIsZero) {
      reqDataCenters.keyword = ''
    }
    if (loading) {
      return
    }
    try {
      reqDataCenters.page = 1
      const result = await srGetHospitalList(reqDataCenters)
      setPageCount(prevState => prevState + 1)
      setCenterListResponse(result)
      setPageLength(result?.contents?.center_list?.length)
      // fireGATag(result?.contents?.center_list, result)
      setCompleteCenterList([...result?.contents?.center_list])
      // if (result?.contents?.center_list?.length < 1 && searchKeyword.value !== '') {
      //   raiseGAEventForVaccination({ new_Category: config.gaBookAppointment, new_Action: config.gaSearchNoResult, new_Label: searchKeyword.value })
      // }
      // if (result?.contents?.center_list?.length >= 1 && searchKeyword.value !== '') {
      //   raiseGAEventForVaccination({ new_Category: config.gaBookAppointment, new_Action: config.gaSearchSelected, new_Label: searchKeyword.value })
      // }
      setLoading(false)
    } catch (e) {
      console.log('e', e)
      // raiseGAEventForVaccination({ new_Action: `${config.gaPincodeSelection} Failure`, new_Label: userLocationFromDetect.pincode, new_Category: config.gaBookAppointment, failureReason: t('BOOK_ERROR_TEXT') })
      setIsError(true)
      setLoading(false)
    }
  }

  const getAppendedCentersList = async () => {
    if (loading) {
      return
    }
    try {
      const result = await srGetHospitalList(reqDataCenters)
      setLoading(false)
      setPageCount(prevState => prevState + 1)
      setCenterListResponse(result)
      setPageLength(result?.contents?.center_list?.length)
      setCompleteCenterList([...completeCenterList, ...result?.contents?.center_list])
    } catch (e) {
      console.log('e', e)
      setIsError(true)
      setLoading(false)
    }
  }
  // useEffect(() => {
  //   if (window.location.pathname === '/book-appointment/corporate') {
  //     sendPageViewEvent({ VirtualPageTitle: 'book-appointment/corporate-centers' })
  //   } else {
  //     sendPageViewEvent({ VirtualPageTitle: 'book-appointment/all-centers' })
  //   }
  // }, [])

  useEffect(() => {
    if (userLocationFromPincode?.longitude && !isError) {
      setLoading(true)
      getCentersList(true)
    }
  }, [userLocationFromPincode, userLocationFromDetect])

  useEffect(() => {
    if (searchKey.length >= 3) {
      setLoading(true)
      setCompleteCenterList([])
      getCentersList()
    }
  }, [searchKey])

  const loadFunction = () => {
    getAppendedCentersList()
  }
  const onTryAgainButtonClick = () => {
    setLoading(true)
    setIsError(false)
    setCompleteCenterList([])
    getCentersList()
  }

  // const fireGATag = (items, response) => {
  //   if (items.length > 0) {
  //     raiseGAEventForVaccination({ new_Action: `${config.gaPincodeSelection} Success`, new_Label: userLocationFromDetect.pincode, new_Category: config.gaBookAppointment, failureReason: 'NA' })
  //     return
  //   }
  //   raiseGAEventForVaccination({ new_Action: `${config.gaPincodeSelection} Failure`, new_Label: userLocationFromDetect.pincode, new_Category: config.gaBookAppointment, failureReason: lodash.get(response, "response.data.message", t('BOOK_ERROR_TEXT')) })
  // }

  return (
    <div>
      {
        isError ? <ErrorComponent
          image={BookErrorIcon}
          text={t('BOOK_ERROR_TEXT')}
          textCss='no-appointments-text'
          subTextCss='no-appointments-sub-text'
          showButton
          buttonText={t('TRY_AGAIN_TEXT')}
          buttonClickCallback={onTryAgainButtonClick}
        />
          :
          <div style={{ width: `${isMobile ? '' : '40vw'}` }}>
            {isMobile && <div style={{ fontSize: '1.375rem', color: '#333333', marginBottom: '1rem' }}>{t('BOOK_APPT')}</div>}
            <Search setSearchKeyword={searchKeyword} getCentersList={getCentersList} setSearchKey={value => setSearchKey(value)} setUserLocationFromDetect={setUserLocationFromDetect} userLocationFromDetect={userLocationFromDetect} setUserLocationFromPincode={userLocationFromPincode} />
            {/* <Filter vaccine_options={vaccine_options} /> */}
            <Card pageLength={pageLength} handleNext={props.handleNext} flow={props.flow} completeCenterList={completeCenterList} loadFunction={loadFunction} loading={loading} />
          </div>
      }
    </div>
  )
}
